import React, { Component, createRef } from 'react';
import { serviceAreas } from '../../services/service-areas';
import { ServiceSupplier } from '../../services/service-supplier';
import services from '../../services';

import { debounce } from 'lodash';
import Select, { components } from 'react-select';
import ReactLoading from 'react-loading';
import { SearchIcon } from '../../components/svgs';
import { tableIcons } from './icons';
import PaginationWithGoTo from '../pagination-with-goto/pagination-with-goto';

import './dataTable.min.css';
import './app-supplier-database.css';
import './supplier-database-mini.css';
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { formatAreaLabel } from '../../util';

class SupplierDatabaseMini extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterSearch: {
        searchFilter: '',
        areaId: props.areaUid ? { value: props.areaUid, label: props.areaName } : '',
        kommun: '',
        rating: '',
        order: [{ column: '0', dir: 'asc' }],
        columns: [
          { data: '0', name: 'name' },
          { data: '1', name: 'area' },
          { data: '2', name: 'kommun' },
        ],
        draw: '1',
        start: 0,
      },
      areas: [],
      cities: [],
      data: [],
      isLoading: false,
      addUpdateSupplier: false,
      modalAddAreaShown: false,
      modalAddAreaDataLoading: false,
      showCreditReport: false,
      selectedSupplierIds: [...(props.selectedSupplierIds || [])],
      editSupplierData: [],
      creditReport: {},
      currentPage: 1
    };
    this.tableRef = createRef();
    this.debouncedSearch = debounce(this.fetchSearchData, 1000);
  }

  async componentDidMount() {
    let filterData = this.state.filterSearch;
    const { areaUid, modifySuppName } = this.props;

    if (modifySuppName) {
      this.handleChange(modifySuppName, 'searchFilter');
    } else {
      if (areaUid) filterData.areaId = areaUid;
      this.fetchSuppliers(filterData);
    }

    this.fetchAdditionalData();
  }

  fetchAdditionalData = () => {
    this.fetchCities();
    this.fetchAreas();
  };

  resetFilter = () => {
    this.setState({
      filterSearch: {
        searchFilter: '',
        areaId: '',
        kommun: '',
        rating: '',
        order: [{ column: '0', dir: 'asc' }],
        columns: [
          { data: '0', name: 'name' },
          { data: '1', name: 'area' },
          { data: '2', name: 'kommun' },
        ],
      },
      selectedSupplierIds: [],
    });
  };

  getSupplierIds = () => this.state.selectedSupplierIds;

  toggleSort = colNum => {
    const { filterSearch } = this.state;
    const order = filterSearch.order[0];
    if (order.column !== colNum) {
      order.column = colNum;
      order.dir = 'asc';
    } else {
      order.dir = order.dir === 'asc' ? 'desc' : 'asc';
    }
    this.handleChange([order], 'order');
  };

  handleSupplierRowClick(rowData, selectedIds = this.state.selectedSupplierIds || []) {
    if (!rowData) return;

    const index = selectedIds.findIndex(s => s == rowData.sup_id);
    let newSupplierIds = [...selectedIds];

    if (index <= -1) {
      newSupplierIds.push(rowData.sup_id);
    } else {
      newSupplierIds.splice(index, 1);
    }

    this.setState({ selectedSupplierIds: newSupplierIds });
    if (this.props.selectEvent) this.props.selectEvent(newSupplierIds);
  }

  handleChange = (value, type, togglePage) => {
    let { filterSearch } = this.state;
    let filters = filterSearch;

    if (type !== 'searchFilter') {
      filters[type] = value;
      this.setState({
        filterSearch: filters,
      });
    }

    let filterData = {
      searchFilter: filterSearch.searchFilter,
      areaId: filterSearch.areaId,
      kommun: filterSearch.kommun,
      rating: filterSearch.rating,
      order: filterSearch.order,
      columns: filterSearch.columns,
      start: filterSearch.start,
    };

    if(togglePage){
      this.setState({ currentPage: 1 });
      filterData.start = 0;
    }

    this.fetchSuppliers(filterData);
  };

  renderDropdown = (placeholder, options, type) => {
    const { filterSearch } = this.state;

    const DropdownIndicator = props => {
      const { SortArrow } = tableIcons;
      return (
        <components.DropdownIndicator {...props}>
          <SortArrow />
        </components.DropdownIndicator>
      );
    };

    return (
      <div className="bt-select-wrapper notranslate">
        <div className="bt-select" select="">
          <Select
            isSearchable={false}
            placeholder={placeholder}
            options={options}
            onChange={e => this.handleChange(e.value, type, true)}
            classNamePrefix="supplierDB"
            className="supplierDB-dropdown"
            components={{ DropdownIndicator }}
            defaultValue={filterSearch[type]}
          />
        </div>
      </div>
    );
  };

  checkSelectedSupplier = sup => {
    const { selectedSupplierIds = [] } = this.state;
    return selectedSupplierIds.length ? selectedSupplierIds.findIndex(s => s == sup.sup_id) > -1 : false;
  }

  fetchAreas = async () => {
    const areas = [{ label: this.props.t('filter.area.all', 'Alla'), value: '' }];
    const areasData = await serviceAreas.getAreas();
    areasData.forEach(item => areas.push({ label: formatAreaLabel(item.name, item.accountNumber), value: item._id }));
    this.setState({ areas });
  };

  fetchCities = async () => {
    await services.getCities().then(data => {
      let cities = [{ label: this.props.t('filter.municipality.all', 'Alla'), value: '' }];
      data.forEach(item => cities.push({ label: item, value: item }));
      this.setState({ cities });
    });
  };

  toggleLoader = () => this.setState({ isLoading: !this.state.isLoading });

  fetchSuppliers = async sup => {
    this.toggleLoader();
    sup.mini = true; //fetch data for mini database without credit data
    const data = await ServiceSupplier.fetchSupplier(sup);
    this.toggleLoader();

    if (data.data) {
      let _data = { data: data.data, page: 0, totalCount: data.recordsFiltered };
      this.setState({ data: _data, draw: parseInt(data.draw) + 1 });
    }
  };

  fetchSearchData = input => {
    this.handleChange(input, 'searchFilter');
  };

  search = event => {
    const searchKey = event.target.value;
    let filterData = this.state.filterSearch;
    filterData['searchFilter'] = searchKey;

    this.setState({
      currentPage: 1
    })
    filterData.start = 0

    this.setState({ filterData });
    this.debouncedSearch(searchKey);
  };

  customHeader = (title, colNum) => {
    const { SortArrow } = tableIcons;
    const isActive = this.state.filterSearch.order[0].column === colNum;
    const titleClass = isActive ? 'sorted' : '';

    return (
      <div onClick={() => this.toggleSort(colNum)} className={`sup-db-title ${titleClass}`}>
        {title}
        {isActive && <SortArrow />}
      </div>
    );
  };

  onPageChanged = currentPage => {
    this.setState({ currentPage });
    const pageOffset = (currentPage - 1) * 10;
    this.handleChange(pageOffset, 'start');
  };

  render() {
    const { selectMode, t } = this.props;
    const { data, cities, areas, isLoading, filterSearch, selectedSupplierIds } = this.state;

    return (
      <div className="column-content sp-main-container sp-main-container-mini">
        <div className="sp-filters-main">
          <div className="ar-row">
            <div className="ar-column sp-input-col">
              <div className="bt-search">
                <div className="left">
                  <SearchIcon size={18} />
                </div>

                <div className="right search--wrapper">
                  <input
                    ref={el => (this.inputSearch = el)}
                    name="search"
                    placeholder={t('filter.search.placeholder', 'Sök')}
                    value={filterSearch.searchFilter}
                    onChange={this.search}
                  />
                </div>
              </div>
            </div>

            <div className="ar-column sp-filter-other">
              <div className="sp-filter-other-container">
                {this.renderDropdown(t('filter.area.placeholder', 'Yrkeskategori'), areas, 'areaId')}
                {this.renderDropdown(t('filter.municipality.placeholder', 'Kommun'), cities, 'kommun')}
              </div>
            </div>
          </div>
        </div>

        <div className="sp-db-mini-table">
          <table>
            <thead>
              <tr>
                <th>{this.customHeader(t('table.header.companyName', 'Företagsnamn'), '0')}</th>
                <th>{this.customHeader(t('table.header.area', 'Yrkesområde'), '1')}</th>
                <th>{this.customHeader(t('table.header.municipality', 'Kommun'), '2')}</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr className="miniDatabaseRow--empty"><td colSpan={3}><ReactLoading className="miniDatabaseRow__loading" color="#ff5e15" type="spin" width="25px" height="25px" /></td></tr>
              ) : data.data?.length ? (
                data.data.map(sup => (
                  <tr
                    className={`${this.checkSelectedSupplier(sup) ? 'selected' : ''} miniDatabaseRow`}
                    onClick={() => this.handleSupplierRowClick(sup)}
                  >
                    <td>{sup.sup_name}</td>
                    <td>{sup.area}</td>
                    <td>{sup.city}</td>
                  </tr>
                ))
              ) : (
                <tr className="miniDatabaseRow--empty">
                  <td colSpan={3}>{ t('table.emptyMessage', 'Kunde inte hitta något resultat') }</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {!selectMode && data.totalCount > 0 && (
          <div className="sup-pagination">
            <PaginationWithGoTo
              count={Math.ceil(data.totalCount/10)}
              onChange={(_, value) => this.onPageChanged(value)}
              page={this.state.currentPage}
              t={i18n.getFixedT(null, 'pagination', 'pagination')}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation('supplierDatabase', { withRef: true })(SupplierDatabaseMini);
